import { render, staticRenderFns } from "./ObserveTable.vue?vue&type=template&id=14f3cb8e&"
import script from "./ObserveTable.vue?vue&type=script&lang=js&"
export * from "./ObserveTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports